import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.setupTooltips()
  }

  setupTooltips() {
    const labels = document.querySelectorAll('td.entry-label[title]')

    labels.forEach(label => {
      let tooltipTimeout

      label.addEventListener('mouseenter', (e) => {
        const title = label.getAttribute('title')
        if (!title) return

        tooltipTimeout = setTimeout(() => {
          const tooltip = document.createElement('div')
          tooltip.className = 'entry-tooltip'
          tooltip.textContent = title
          tooltip.style.cssText = `
            position: fixed;
            background-color: #333;
            color: white;
            padding: 8px 12px;
            border-radius: 4px;
            font-size: 0.9em;
            max-width: 300px;
            word-wrap: break-word;
            z-index: 10000;
            pointer-events: none;
            box-shadow: 0 2px 8px rgba(0,0,0,0.2);
          `

          document.body.appendChild(tooltip)

          const rect = label.getBoundingClientRect()
          tooltip.style.left = (rect.left + rect.width / 2 - tooltip.offsetWidth / 2) + 'px'
          tooltip.style.top = (rect.top - tooltip.offsetHeight - 8) + 'px'

          const cleanup = () => {
            tooltip.remove()
            label.removeEventListener('mouseleave', cleanup)
          }

          label.addEventListener('mouseleave', cleanup)
        }, 200)
      })

      label.addEventListener('mouseleave', () => {
        clearTimeout(tooltipTimeout)
      })
    })
  }
}

